import type { PageBuyer } from '../../../lib/aiJobSummary';
import { OpCard } from './SectionHeading';

const label: React.CSSProperties = { fontSize: 'var(--text-xs)', color: 'var(--text-faint)', whiteSpace: 'nowrap' };
const value: React.CSSProperties = { fontSize: 'var(--text-sm)', color: 'var(--text-body)', lineHeight: 'var(--leading-snug)' };

/**
 * Page Build jobs: who the page is for. Every section is ordered to move this person to `action`, and the buyer test
 * after the build reads the page as them. Read this first when approving: a wrong buyer means a wrong page.
 */
export default function PageBuyerCard({ buyer }: { buyer: PageBuyer }) {
  const rows: [string, React.ReactNode][] = [
    ['Who', buyer.who],
    ['Wants', buyer.wants],
    ['Already knows', buyer.knows],
    ['Holds them back', buyer.objections?.length ? buyer.objections.join(' · ') : '—'],
    ['The promise', buyer.promise],
  ];
  return (
    <OpCard tone="raised">
      <div style={{ display: 'flex', alignItems: 'baseline', gap: '10px', marginBottom: '10px', flexWrap: 'wrap' }}>
        <span className="t-eyebrow" style={{ color: 'var(--text-faint)' }}>
          Who this page is for
        </span>
        <span style={{ flex: 1 }} />
        <span style={{ fontSize: 'var(--text-sm)', color: 'var(--accent-text)' }}>
          The action: <span style={{ fontWeight: 'var(--weight-medium)' as React.CSSProperties['fontWeight'] }}>{buyer.action}</span>
        </span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'auto minmax(0, 1fr)', gap: '6px 16px' }}>
        {rows.map(([k, v]) => (
          <div key={k} style={{ display: 'contents' }}>
            <span style={label}>{k}</span>
            <span style={value}>{v}</span>
          </div>
        ))}
      </div>
    </OpCard>
  );
}
